import React, { useState, useEffect } from 'react';
import { X, Medal, Shield, Users, Calendar, MapPin, Sparkles, ChevronLeft, ChevronRight, ArrowDownUp, Search } from 'lucide-react';

// Team stats data
const TEAM_STATS = {
    // South Region
    "Auburn": {"record": "28-5", "bpi": 22.3, "bpi_rank": 3, "offensive_efficiency": 12.9, "defensive_efficiency": 9.4, "overall_efficiency": 22.3, "strength": "Offense"},
    "Alabama State": {"record": "17-15", "bpi": -0.4, "bpi_rank": 163, "offensive_efficiency": -3.5, "defensive_efficiency": 3.2, "overall_efficiency": -0.4, "strength": "Defense"},
    "Louisville": {"record": "27-7", "bpi": 14.0, "bpi_rank": 28, "offensive_efficiency": 6.6, "defensive_efficiency": 7.4, "overall_efficiency": 14.0, "strength": "Defense"},
    "Creighton": {"record": "24-10", "bpi": 14.6, "bpi_rank": 26, "offensive_efficiency": 7.8, "defensive_efficiency": 6.8, "overall_efficiency": 14.6, "strength": "Offense"},
    "Michigan": {"record": "24-9", "bpi": 13.8, "bpi_rank": 29, "offensive_efficiency": 6.5, "defensive_efficiency": 7.2, "overall_efficiency": 13.8, "strength": "Defense"},
    "UC San Diego": {"record": "30-4", "bpi": 9.6, "bpi_rank": 57, "offensive_efficiency": 4.5, "defensive_efficiency": 5.1, "overall_efficiency": 9.6, "strength": "Defense"},
    "Texas A&M": {"record": "21-12", "bpi": 18.2, "bpi_rank": 9, "offensive_efficiency": 10.3, "defensive_efficiency": 7.9, "overall_efficiency": 18.2, "strength": "Offense"},
    "Yale": {"record": "19-13", "bpi": -2.3, "bpi_rank": 202, "offensive_efficiency": -3.3, "defensive_efficiency": 1.1, "overall_efficiency": -2.3, "strength": "Defense"},
    "Ole Miss": {"record": "21-11", "bpi": 3.6, "bpi_rank": 110, "offensive_efficiency": -0.2, "defensive_efficiency": 3.7, "overall_efficiency": 3.6, "strength": "Defense"},
    "San Diego State": {"record": "19-13", "bpi": 10.6, "bpi_rank": 51, "offensive_efficiency": 2.4, "defensive_efficiency": 8.3, "overall_efficiency": 10.6, "strength": "Defense"},
    "North Carolina": {"record": "21-11", "bpi": 12.5, "bpi_rank": 39, "offensive_efficiency": 6.5, "defensive_efficiency": 6.0, "overall_efficiency": 12.5, "strength": "Offense"},
    "Iowa State": {"record": "25-8", "bpi": 16.9, "bpi_rank": 13, "offensive_efficiency": 6.8, "defensive_efficiency": 10.1, "overall_efficiency": 16.9, "strength": "Defense"},
    "Lipscomb": {"record": "23-11", "bpi": 0.6, "bpi_rank": 145, "offensive_efficiency": -0.6, "defensive_efficiency": 1.2, "overall_efficiency": 0.6, "strength": "Defense"},
    "Marquette": {"record": "22-11", "bpi": 3.6, "bpi_rank": 109, "offensive_efficiency": -0.2, "defensive_efficiency": 3.9, "overall_efficiency": 3.6, "strength": "Defense"},
    "New Mexico": {"record": "26-7", "bpi": 10.8, "bpi_rank": 49, "offensive_efficiency": 3.8, "defensive_efficiency": 7.1, "overall_efficiency": 10.8, "strength": "Defense"},
    "Michigan State": {"record": "27-6", "bpi": 17.3, "bpi_rank": 11, "offensive_efficiency": 7.0, "defensive_efficiency": 10.3, "overall_efficiency": 17.3, "strength": "Defense"},
    "Bryant": {"record": "19-15", "bpi": -6.6, "bpi_rank": 276, "offensive_efficiency": -4.6, "defensive_efficiency": -2.0, "overall_efficiency": -6.6, "strength": "Defense"},
    
    // East Region
    "Duke": {"record": "25-8", "bpi": 19.2, "bpi_rank": 6, "offensive_efficiency": 12.4, "defensive_efficiency": 6.8, "overall_efficiency": 19.2, "strength": "Offense"},
    "American": {"record": "19-14", "bpi": -5.4, "bpi_rank": 257, "offensive_efficiency": 0.4, "defensive_efficiency": -5.8, "overall_efficiency": -5.4, "strength": "Offense"},
    "Mount St. Mary's": {"record": "19-15", "bpi": -4.7, "bpi_rank": 243, "offensive_efficiency": -5.7, "defensive_efficiency": 0.9, "overall_efficiency": -4.7, "strength": "Defense"},
    "Mississippi State": {"record": "20-12", "bpi": 1.0, "bpi_rank": 137, "offensive_efficiency": -0.6, "defensive_efficiency": 1.5, "overall_efficiency": 1.0, "strength": "Defense"},
    "Baylor": {"record": "20-12", "bpi": 7.9, "bpi_rank": 69, "offensive_efficiency": 4.8, "defensive_efficiency": 3.1, "overall_efficiency": 7.9, "strength": "Offense"},
    "Oregon": {"record": "24-9", "bpi": 18.2, "bpi_rank": 8, "offensive_efficiency": 10.8, "defensive_efficiency": 7.1, "overall_efficiency": 18.2, "strength": "Offense"},
    "Liberty": {"record": "28-6", "bpi": 6.4, "bpi_rank": 85, "offensive_efficiency": 2.3, "defensive_efficiency": 4.1, "overall_efficiency": 6.4, "strength": "Defense"},
    "Arizona": {"record": "24-9", "bpi": 15.1, "bpi_rank": 24, "offensive_efficiency": 9.3, "defensive_efficiency": 5.7, "overall_efficiency": 15.1, "strength": "Offense"},
    "Akron": {"record": "28-6", "bpi": 3.2, "bpi_rank": 112, "offensive_efficiency": 2.7, "defensive_efficiency": 0.4, "overall_efficiency": 3.2, "strength": "Offense"},
    "BYU": {"record": "23-10", "bpi": 14.4, "bpi_rank": 27, "offensive_efficiency": 6.5, "defensive_efficiency": 8.0, "overall_efficiency": 14.4, "strength": "Defense"},
    "VCU": {"record": "27-6", "bpi": 13.4, "bpi_rank": 33, "offensive_efficiency": 5.5, "defensive_efficiency": 7.9, "overall_efficiency": 13.4, "strength": "Defense"},
    "Wisconsin": {"record": "26-8", "bpi": 16.1, "bpi_rank": 18, "offensive_efficiency": 9.5, "defensive_efficiency": 6.6, "overall_efficiency": 16.1, "strength": "Offense"},
    "Montana": {"record": "24-9", "bpi": 1.3, "bpi_rank": 128, "offensive_efficiency": 2.5, "defensive_efficiency": -1.2, "overall_efficiency": 1.3, "strength": "Offense"},
    "Saint Mary's": {"record": "28-5", "bpi": 13.7, "bpi_rank": 30, "offensive_efficiency": 5.1, "defensive_efficiency": 8.6, "overall_efficiency": 13.7, "strength": "Defense"},
    "Vanderbilt": {"record": "19-14", "bpi": 15.9, "bpi_rank": 19, "offensive_efficiency": 10.0, "defensive_efficiency": 5.9, "overall_efficiency": 15.9, "strength": "Offense"},
    "Alabama": {"record": "24-9", "bpi": 18.7, "bpi_rank": 7, "offensive_efficiency": 8.2, "defensive_efficiency": 10.5, "overall_efficiency": 18.7, "strength": "Defense"},
    "Robert Morris": {"record": "26-8", "bpi": -0.9, "bpi_rank": 168, "offensive_efficiency": -1.4, "defensive_efficiency": 0.5, "overall_efficiency": -0.9, "strength": "Defense"},
    
    // Midwest Region
    "Houston": {"record": "30-4", "bpi": 23.8, "bpi_rank": 2, "offensive_efficiency": 10.7, "defensive_efficiency": 13.1, "overall_efficiency": 23.8, "strength": "Defense"},
    "SIU Edwardsville": {"record": "21-12", "bpi": -4.7, "bpi_rank": 243, "offensive_efficiency": -5.7, "defensive_efficiency": 0.9, "overall_efficiency": -4.7, "strength": "Defense"},
    "Gonzaga": {"record": "25-8", "bpi": 17.9, "bpi_rank": 10, "offensive_efficiency": 10.8, "defensive_efficiency": 7.1, "overall_efficiency": 17.9, "strength": "Offense"},
    "Georgia": {"record": "20-12", "bpi": 10.0, "bpi_rank": 56, "offensive_efficiency": 6.3, "defensive_efficiency": 3.6, "overall_efficiency": 10.0, "strength": "Offense"},
    "Clemson": {"record": "27-6", "bpi": 16.4, "bpi_rank": 15, "offensive_efficiency": 8.2, "defensive_efficiency": 8.2, "overall_efficiency": 16.4, "strength": "Balanced"},
    "McNeese": {"record": "27-6", "bpi": 8.3, "bpi_rank": 66, "offensive_efficiency": 4.7, "defensive_efficiency": 3.7, "overall_efficiency": 8.3, "strength": "Offense"},
    "Purdue": {"record": "22-11", "bpi": 15.7, "bpi_rank": 21, "offensive_efficiency": 10.4, "defensive_efficiency": 5.4, "overall_efficiency": 15.7, "strength": "Offense"},
    "High Point": {"record": "29-5", "bpi": 6.8, "bpi_rank": 81, "offensive_efficiency": 7.2, "defensive_efficiency": -0.3, "overall_efficiency": 6.8, "strength": "Offense"},
    "Illinois": {"record": "23-10", "bpi": 11.5, "bpi_rank": 45, "offensive_efficiency": 6.7, "defensive_efficiency": 4.8, "overall_efficiency": 11.5, "strength": "Offense"},
    "Texas": {"record": "20-12", "bpi": 12.5, "bpi_rank": 38, "offensive_efficiency": 5.4, "defensive_efficiency": 7.1, "overall_efficiency": 12.5, "strength": "Defense"},
    "Xavier": {"record": "20-13", "bpi": -1.4, "bpi_rank": 179, "offensive_efficiency": -1.6, "defensive_efficiency": 0.3, "overall_efficiency": -1.4, "strength": "Defense"},
    "Kentucky": {"record": "19-13", "bpi": 10.6, "bpi_rank": 52, "offensive_efficiency": 4.6, "defensive_efficiency": 6.0, "overall_efficiency": 10.6, "strength": "Defense"},
    "Troy": {"record": "21-12", "bpi": -1.7, "bpi_rank": 190, "offensive_efficiency": 0.7, "defensive_efficiency": -2.4, "overall_efficiency": -1.7, "strength": "Offense"},
    "UCLA": {"record": "24-10", "bpi": 6.0, "bpi_rank": 91, "offensive_efficiency": 3.1, "defensive_efficiency": 2.9, "overall_efficiency": 6.0, "strength": "Offense"},
    "Utah State": {"record": "26-7", "bpi": 11.5, "bpi_rank": 44, "offensive_efficiency": 8.9, "defensive_efficiency": 2.6, "overall_efficiency": 11.5, "strength": "Offense"},
    "Tennessee": {"record": "27-6", "bpi": 19.5, "bpi_rank": 5, "offensive_efficiency": 8.7, "defensive_efficiency": 10.8, "overall_efficiency": 19.5, "strength": "Defense"},
    "Wofford": {"record": "17-16", "bpi": -7.5, "bpi_rank": 291, "offensive_efficiency": -7.9, "defensive_efficiency": 0.4, "overall_efficiency": -7.5, "strength": "Defense"},
    
    // West Region
    "Florida": {"record": "29-4", "bpi": 20.1, "bpi_rank": 4, "offensive_efficiency": 11.4, "defensive_efficiency": 8.7, "overall_efficiency": 20.1, "strength": "Offense"},
    "Norfolk State": {"record": "20-10", "bpi": -5.6, "bpi_rank": 263, "offensive_efficiency": -6.3, "defensive_efficiency": 0.7, "overall_efficiency": -5.6, "strength": "Defense"},
    "UConn": {"record": "22-13", "bpi": 14.8, "bpi_rank": 25, "offensive_efficiency": 8.7, "defensive_efficiency": 6.1, "overall_efficiency": 14.8, "strength": "Offense"},
    "Oklahoma": {"record": "20-12", "bpi": 1.4, "bpi_rank": 125, "offensive_efficiency": 1.3, "defensive_efficiency": -0.1, "overall_efficiency": 1.4, "strength": "Offense"},
    "Memphis": {"record": "28-5", "bpi": 11.3, "bpi_rank": 46, "offensive_efficiency": 4.9, "defensive_efficiency": 6.3, "overall_efficiency": 11.3, "strength": "Defense"},
    "Colorado State": {"record": "25-9", "bpi": 10.5, "bpi_rank": 53, "offensive_efficiency": 5.2, "defensive_efficiency": 5.3, "overall_efficiency": 10.5, "strength": "Defense"},
    "Maryland": {"record": "21-12", "bpi": 16.1, "bpi_rank": 17, "offensive_efficiency": 10.5, "defensive_efficiency": 5.7, "overall_efficiency": 16.1, "strength": "Offense"},
    "Grand Canyon": {"record": "26-7", "bpi": 6.2, "bpi_rank": 87, "offensive_efficiency": 1.2, "defensive_efficiency": 5.0, "overall_efficiency": 6.2, "strength": "Defense"},
    "Missouri": {"record": "21-11", "bpi": 0.6, "bpi_rank": 146, "offensive_efficiency": 0.2, "defensive_efficiency": 0.4, "overall_efficiency": 0.6, "strength": "Defense"},
    "Drake": {"record": "30-3", "bpi": 7.6, "bpi_rank": 73, "offensive_efficiency": 2.6, "defensive_efficiency": 5.0, "overall_efficiency": 7.6, "strength": "Defense"},
    "Texas Tech": {"record": "24-9", "bpi": 13.2, "bpi_rank": 36, "offensive_efficiency": 6.4, "defensive_efficiency": 6.8, "overall_efficiency": 13.2, "strength": "Defense"},
    "UNC Wilmington": {"record": "27-7", "bpi": 3.5, "bpi_rank": 111, "offensive_efficiency": 3.7, "defensive_efficiency": -0.2, "overall_efficiency": 3.5, "strength": "Offense"},
    "Kansas": {"record": "20-13", "bpi": 11.7, "bpi_rank": 42, "offensive_efficiency": 4.4, "defensive_efficiency": 7.2, "overall_efficiency": 11.7, "strength": "Defense"},
    "Arkansas": {"record": "19-14", "bpi": 11.8, "bpi_rank": 41, "offensive_efficiency": 7.9, "defensive_efficiency": 3.9, "overall_efficiency": 11.8, "strength": "Offense"},
    "St. John's": {"record": "30-4", "bpi": 17.0, "bpi_rank": 12, "offensive_efficiency": 5.6, "defensive_efficiency": 11.4, "overall_efficiency": 17.0, "strength": "Defense"},
    "Omaha": {"record": "21-13", "bpi": -0.1, "bpi_rank": 157, "offensive_efficiency": 0.4, "defensive_efficiency": -0.5, "overall_efficiency": -0.1, "strength": "Offense"}
};

// Bracket data
// const MARCH_MADNESS_BRACKET = {
//     "south": [
//         {"matchup_id": "S1", "round": 1, "location": "Lexington", "date": "Thursday", "team1": {"seed": 1, "name": "Auburn"}, "team2": {"seed": 16, "name": "Alabama State/Saint Francis"}},
//         {"matchup_id": "S2", "round": 1, "location": "Lexington", "date": "Thursday", "team1": {"seed": 8, "name": "Louisville"}, "team2": {"seed": 9, "name": "Creighton"}},
//         {"matchup_id": "S3", "round": 1, "location": "Denver", "date": "Thursday", "team1": {"seed": 5, "name": "Michigan"}, "team2": {"seed": 12, "name": "UC San Diego"}},
//         {"matchup_id": "S4", "round": 1, "location": "Denver", "date": "Thursday", "team1": {"seed": 4, "name": "Texas A&M"}, "team2": {"seed": 13, "name": "Yale"}},
//         {"matchup_id": "S5", "round": 1, "location": "Milwaukee", "date": "Friday", "team1": {"seed": 6, "name": "Ole Miss"}, "team2": {"seed": 11, "name": "San Diego State/North Carolina"}},
//         {"matchup_id": "S6", "round": 1, "location": "Milwaukee", "date": "Friday", "team1": {"seed": 3, "name": "Iowa State"}, "team2": {"seed": 14, "name": "Lipscomb"}},
//         {"matchup_id": "S7", "round": 1, "location": "Cleveland", "date": "Friday", "team1": {"seed": 7, "name": "Marquette"}, "team2": {"seed": 10, "name": "New Mexico"}},
//         {"matchup_id": "S8", "round": 1, "location": "Cleveland", "date": "Friday", "team1": {"seed": 2, "name": "Michigan State"}, "team2": {"seed": 15, "name": "Bryant"}}
//     ],
//     "east": [
//         {"matchup_id": "E1", "round": 1, "location": "Raleigh", "date": "Friday", "team1": {"seed": 1, "name": "Duke"}, "team2": {"seed": 16, "name": "American/Mount St. Mary's"}},
//         {"matchup_id": "E2", "round": 1, "location": "Raleigh", "date": "Friday", "team1": {"seed": 8, "name": "Mississippi State"}, "team2": {"seed": 9, "name": "Baylor"}},
//         {"matchup_id": "E3", "round": 1, "location": "Seattle", "date": "Friday", "team1": {"seed": 5, "name": "Oregon"}, "team2": {"seed": 12, "name": "Liberty"}},
//         {"matchup_id": "E4", "round": 1, "location": "Seattle", "date": "Friday", "team1": {"seed": 4, "name": "Arizona"}, "team2": {"seed": 13, "name": "Akron"}},
//         {"matchup_id": "E5", "round": 1, "location": "Denver", "date": "Thursday", "team1": {"seed": 6, "name": "BYU"}, "team2": {"seed": 11, "name": "VCU"}},
//         {"matchup_id": "E6", "round": 1, "location": "Denver", "date": "Thursday", "team1": {"seed": 3, "name": "Wisconsin"}, "team2": {"seed": 14, "name": "Montana"}},
//         {"matchup_id": "E7", "round": 1, "location": "Cleveland", "date": "Friday", "team1": {"seed": 7, "name": "Saint Mary's"}, "team2": {"seed": 10, "name": "Vanderbilt"}},
//         {"matchup_id": "E8", "round": 1, "location": "Cleveland", "date": "Friday", "team1": {"seed": 2, "name": "Alabama"}, "team2": {"seed": 15, "name": "Robert Morris"}}
//     ],
//     "midwest": [
//         {"matchup_id": "MW1", "round": 1, "location": "Wichita", "date": "Thursday", "team1": {"seed": 1, "name": "Houston"}, "team2": {"seed": 16, "name": "SIU Edwardsville"}},
//         {"matchup_id": "MW2", "round": 1, "location": "Wichita", "date": "Thursday", "team1": {"seed": 8, "name": "Gonzaga"}, "team2": {"seed": 9, "name": "Georgia"}},
//         {"matchup_id": "MW3", "round": 1, "location": "Providence", "date": "Thursday", "team1": {"seed": 5, "name": "Clemson"}, "team2": {"seed": 12, "name": "McNeese"}},
//         {"matchup_id": "MW4", "round": 1, "location": "Providence", "date": "Thursday", "team1": {"seed": 4, "name": "Purdue"}, "team2": {"seed": 13, "name": "High Point"}},
//         {"matchup_id": "MW5", "round": 1, "location": "Milwaukee", "date": "Friday", "team1": {"seed": 6, "name": "Illinois"}, "team2": {"seed": 11, "name": "Texas/Xavier"}},
//         {"matchup_id": "MW6", "round": 1, "location": "Milwaukee", "date": "Friday", "team1": {"seed": 3, "name": "Kentucky"}, "team2": {"seed": 14, "name": "Troy"}},
//         {"matchup_id": "MW7", "round": 1, "location": "Lexington", "date": "Thursday", "team1": {"seed": 7, "name": "UCLA"}, "team2": {"seed": 10, "name": "Utah State"}},
//         {"matchup_id": "MW8", "round": 1, "location": "Lexington", "date": "Thursday", "team1": {"seed": 2, "name": "Tennessee"}, "team2": {"seed": 15, "name": "Wofford"}}
//     ],
//     "west": [
//         {"matchup_id": "W1", "round": 1, "location": "Raleigh", "date": "Friday", "team1": {"seed": 1, "name": "Florida"}, "team2": {"seed": 16, "name": "Norfolk State"}},
//         {"matchup_id": "W2", "round": 1, "location": "Raleigh", "date": "Friday", "team1": {"seed": 8, "name": "UConn"}, "team2": {"seed": 9, "name": "Oklahoma"}},
//         {"matchup_id": "W3", "round": 1, "location": "Seattle", "date": "Friday", "team1": {"seed": 5, "name": "Memphis"}, "team2": {"seed": 12, "name": "Colorado State"}},
//         {"matchup_id": "W4", "round": 1, "location": "Seattle", "date": "Friday", "team1": {"seed": 4, "name": "Maryland"}, "team2": {"seed": 13, "name": "Grand Canyon"}},
//         {"matchup_id": "W5", "round": 1, "location": "Wichita", "date": "Thursday", "team1": {"seed": 6, "name": "Missouri"}, "team2": {"seed": 11, "name": "Drake"}},
//         {"matchup_id": "W6", "round": 1, "location": "Wichita", "date": "Thursday", "team1": {"seed": 3, "name": "Texas Tech"}, "team2": {"seed": 14, "name": "UNC Wilmington"}},
//         {"matchup_id": "W7", "round": 1, "location": "Providence", "date": "Thursday", "team1": {"seed": 7, "name": "Kansas"}, "team2": {"seed": 10, "name": "Arkansas"}},
//         {"matchup_id": "W8", "round": 1, "location": "Providence", "date": "Thursday", "team1": {"seed": 2, "name": "St. John's"}, "team2": {"seed": 15, "name": "Omaha"}}
//     ]
// };

// NEW: Second Round (Round of 32) data only:

// Sweet 16 Bracket data (while keeping the same variable name)
export const SECOND_ROUND_BRACKET = {
  "matchups": [
    {
      "matchup_id": "FF-FL-AUB",
      "round": 5,
      "location": "Alamodome, San Antonio, Texas",
      "date": "April 5, 2025",
      "time": "6:09 PM ET",
      "team1": {
        "seed": 1,
        "name": "Florida",
        "stats": {
          "record": "29-4",
          "bpi": 20.1,
          "bpi_rank": 4
        }
      },
      "team2": {
        "seed": 1,
        "name": "Auburn",
        "stats": {
          "record": "28-5",
          "bpi": 22.3,
          "bpi_rank": 3
        }
      }
    },
    {
      "matchup_id": "FF-DUKE-HOU",
      "round": 5,
      "location": "Alamodome, San Antonio, Texas",
      "date": "April 5, 2025",
      "time": "8:49 PM ET",
      "team1": {
        "seed": 1,
        "name": "Duke",
        "stats": {
          "record": "25-8",
          "bpi": 19.2,
          "bpi_rank": 6
        }
      },
      "team2": {
        "seed": 1,
        "name": "Houston",
        "stats": {
          "record": "30-4",
          "bpi": 23.8,
          "bpi_rank": 2
        }
      }
    }
  ]
};



// Helper function to find a team's matchup information
const findTeamMatchup = (teamName) => {
  for (const region in SECOND_ROUND_BRACKET) {
    for (const matchup of SECOND_ROUND_BRACKET[region]) {
      if (matchup.team1.name === teamName) {
        return {
          region: region.charAt(0).toUpperCase() + region.slice(1),
          seed: matchup.team1.seed,
          opponent: matchup.team2.name,
          opponentSeed: matchup.team2.seed,
          location: matchup.location,
          date: matchup.date,
          matchupId: matchup.matchup_id
        };
      }
      if (matchup.team2.name === teamName) {
        return {
          region: region.charAt(0).toUpperCase() + region.slice(1),
          seed: matchup.team2.seed,
          opponent: matchup.team1.name,
          opponentSeed: matchup.team1.seed,
          location: matchup.location,
          date: matchup.date,
          matchupId: matchup.matchup_id
        };
      }
    }
  }
  return null;
};

const DesktopTeamStats = ({ onClose, onSuggestionClick = null }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTeams, setFilteredTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [matchupInfo, setMatchupInfo] = useState(null);
  const [isGeneratingPrompt, setIsGeneratingPrompt] = useState(false);
  const [showOnlySecondRound, setShowOnlySecondRound] = useState(true); // Default to true to show second round teams

  // State for sorting and pagination
  const [sortBy, setSortBy] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const teamsPerPage = 10; // More teams per page for desktop

  // Calculate Power Score - aggregated metric for sorting
  const calculatePowerScore = (team) => {
    // Power score is a weighted combination of BPI and efficiencies
    return team.bpi * 0.5 + team.offensive_efficiency * 0.25 + team.defensive_efficiency * 0.25;
  };

  // Add this helper function to check if a team is in the second round
const isTeamInSecondRound = (teamName) => {
  for (const region in SECOND_ROUND_BRACKET) {
    for (const matchup of SECOND_ROUND_BRACKET[region]) {
      if (matchup.team1.name === teamName || matchup.team2.name === teamName) {
        return true;
      }
    }
  }
  return false;
};

  // Filter and sort teams
  useEffect(() => {
    let results = Object.entries(TEAM_STATS);
    
      // Filter for second round teams if toggle is on
  if (showOnlySecondRound) {
    results = results.filter(([teamName]) => isTeamInSecondRound(teamName));
  }

    // Apply search filter if there's a search term
    if (searchTerm.trim() !== '') {
      results = results.filter(([teamName]) => 
        teamName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    // Add power score to each team for sorting
    results = results.map(([teamName, stats]) => {
      const powerScore = calculatePowerScore(stats);
      return [teamName, { ...stats, powerScore }];
    });
    
    // Apply sorting
    results.sort((a, b) => {
      const teamA = a[1];
      const teamB = b[1];
      
      switch (sortBy) {
        case 'name':
          return sortDirection === 'asc' 
            ? a[0].localeCompare(b[0]) 
            : b[0].localeCompare(a[0]);
        case 'bpi':
          // BPI is the raw power index value (higher is better)
          return sortDirection === 'asc' 
            ? teamA.bpi - teamB.bpi 
            : teamB.bpi - teamA.bpi;
        case 'bpiRank':
          // BPI Rank is the ranking number (lower is better)
          return sortDirection === 'asc' 
            ? teamA.bpi_rank - teamB.bpi_rank 
            : teamB.bpi_rank - teamA.bpi_rank;
        case 'powerScore':
          // Power Score is our calculated combined metric
          return sortDirection === 'asc' 
            ? teamA.powerScore - teamB.powerScore 
            : teamB.powerScore - teamA.powerScore;
        case 'offense':
          // Sort by offensive efficiency
          return sortDirection === 'asc'
            ? teamA.offensive_efficiency - teamB.offensive_efficiency
            : teamB.offensive_efficiency - teamA.offensive_efficiency;
        case 'defense':
          // Sort by defensive efficiency
          return sortDirection === 'asc'
            ? teamA.defensive_efficiency - teamB.defensive_efficiency
            : teamB.defensive_efficiency - teamA.defensive_efficiency;
        default:
          return 0;
      }
    });
    
    setFilteredTeams(results);
    
    // Reset to first page when search/sort changes
    setCurrentPage(1);
  }, [searchTerm, sortBy, sortDirection, showOnlySecondRound]);

  // Set matchup info when a team is selected
  useEffect(() => {
    if (selectedTeam) {
      const teamName = selectedTeam[0];
      const matchup = findTeamMatchup(teamName);
      setMatchupInfo(matchup);
    } else {
      setMatchupInfo(null);
    }
  }, [selectedTeam]);

  // Function to handle asking AI for odds
  const handleAskForOdds = () => {
    if (!selectedTeam || !matchupInfo || !onSuggestionClick) return;
    
    setIsGeneratingPrompt(true);
    
    // Format a comprehensive prompt for the AI to analyze
    const prompt = `Get the odds for the March Madness matchup between ${selectedTeam[0]} (${matchupInfo.seed} seed) and ${matchupInfo.opponent} (${matchupInfo.opponentSeed} seed) in the ${matchupInfo.region} region.

${selectedTeam[0]} has a record of ${selectedTeam[1].record}, BPI rank of #${selectedTeam[1].bpi_rank}, offensive efficiency of ${selectedTeam[1].offensive_efficiency.toFixed(1)}, and defensive efficiency of ${selectedTeam[1].defensive_efficiency.toFixed(1)}.

Consider their strengths (${selectedTeam[1].strength}), briefly make recommended bet using odds / spreads based on which team has the advantage.`;
    
    // Send the prompt to the AI
    onSuggestionClick(prompt);
    
    // Close the panel
    setTimeout(() => {
      onClose(); 
      setIsGeneratingPrompt(false);
    }, 500);
  };

  // Toggle sort direction
  const toggleSort = (sortKey) => {
    if (sortBy === sortKey) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(sortKey);
      setSortDirection('desc'); // Default to descending for new sort fields
    }
  };

  // Calculate pagination
  const totalPages = Math.ceil(filteredTeams.length / teamsPerPage);
  const paginatedTeams = filteredTeams.slice(
    (currentPage - 1) * teamsPerPage,
    currentPage * teamsPerPage
  );

  // Pagination controls
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Get sort indicator
  const getSortIndicator = (key) => {
    if (sortBy !== key) return null;
    
    return (
      <span className={`ml-1 text-xs ${sortDirection === 'asc' ? 'text-emerald-400' : 'text-emerald-300'}`}>
        {sortDirection === 'asc' ? '↑' : '↓'}
      </span>
    );
  };

  return (
    <div className="flex flex-col h-full max-h-[80vh]">
      {/* Header with close button */}
      <div className="p-4 border-b border-slate-700 flex items-center justify-between bg-slate-800 sticky top-0 z-10">
        <div className="flex items-center">
          <Medal className="w-5 h-5 text-emerald-400 mr-2" />
          <h2 className="text-lg font-medium text-emerald-300">March Madness Team Stats</h2>
        </div>
        <button 
          onClick={onClose}
          className="p-1.5 rounded-full hover:bg-slate-700/50 text-slate-400 hover:text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
      
      {/* Main content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left side: Team list */}
        <div className={`${selectedTeam ? 'w-1/3 border-r border-slate-700' : 'w-full'} overflow-y-auto`}>
          <div className="p-4 sticky top-0 bg-slate-900 z-10">
            <p className="text-sm text-slate-400 mb-4">
              Search for NCAA basketball teams to view their stats and bracket matchups
            </p>
            
            {/* Search input */}
            <div className="relative mb-4">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-4 w-4 text-slate-400" />
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search teams..."
                className="w-full bg-slate-800 border border-slate-700 rounded-lg py-2 pl-10 pr-3 text-white placeholder-slate-500 focus:outline-none focus:ring-1 focus:ring-emerald-500"
              />
            </div>

          {/* Second round filter */}
            <div className="mb-4 flex items-center">
            <input
              type="checkbox"
              id="second-round-filter"
              checked={showOnlySecondRound}
              onChange={(e) => setShowOnlySecondRound(e.target.checked)}
              className="mr-2 h-4 w-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500"
            />
            <label htmlFor="second-round-filter" className="text-sm text-slate-400">
              Show only Final 4 Round teams
            </label>
          </div>

            {/* Sort controls */}
            <div className="mb-4">
              <div className="text-xs text-slate-400 mb-2">Sort teams</div>
              <div className="flex flex-wrap gap-2">
                <button 
                  onClick={() => toggleSort('bpi')}
                  className={`px-3 py-1.5 text-xs font-medium rounded-lg flex items-center 
                    ${sortBy === 'bpi' ? 'bg-emerald-900/40 text-emerald-300 border border-emerald-700/50' : 'bg-slate-800 text-slate-300 border border-slate-700 hover:bg-slate-700'}`}
                >
                  Power Index{getSortIndicator('bpi')}
                </button>
                <button 
                  onClick={() => toggleSort('offense')}
                  className={`px-3 py-1.5 text-xs font-medium rounded-lg flex items-center 
                    ${sortBy === 'offense' ? 'bg-red-900/40 text-red-300 border border-red-700/50' : 'bg-slate-800 text-slate-300 border border-slate-700 hover:bg-slate-700'}`}
                >
                  Offense{getSortIndicator('offense')}
                </button>
                <button 
                  onClick={() => toggleSort('defense')}
                  className={`px-3 py-1.5 text-xs font-medium rounded-lg flex items-center 
                    ${sortBy === 'defense' ? 'bg-blue-900/40 text-blue-300 border border-blue-700/50' : 'bg-slate-800 text-slate-300 border border-slate-700 hover:bg-slate-700'}`}
                >
                  Defense{getSortIndicator('defense')}
                </button>
              </div>
            </div>
          </div>

          {/* Team list */}
          <div className="px-4 pb-4 space-y-2">
            {paginatedTeams.length > 0 ? (
              paginatedTeams.map(([teamName, stats]) => {
                const matchup = findTeamMatchup(teamName);
                return (
                  <button
                    key={teamName}
                    onClick={() => setSelectedTeam([teamName, stats])}
                    className={`w-full text-left p-3 border rounded-lg flex items-center
                      ${selectedTeam && selectedTeam[0] === teamName 
                        ? 'bg-emerald-900/20 hover:bg-emerald-900/30 border-emerald-700/50' 
                        : 'bg-slate-800/50 hover:bg-slate-700/50 border-slate-700/50'}`}
                  >
                    {/* Seed Number */}
                    {matchup && (
                      <span className="w-6 h-6 flex-shrink-0 rounded-full bg-emerald-900/60 text-emerald-300 text-xs font-bold flex items-center justify-center mr-3">
                        {matchup.seed}
                      </span>
                    )}
                    
                    {/* Team Name and Record */}
                    <div className="flex-grow min-w-0">
                      <div className="text-white font-medium truncate">{teamName}</div>
                      <div className="text-xs text-slate-400 truncate">
                        {stats.record} {matchup && `• vs ${matchup.opponent.split('/')[0]}`}
                      </div>
                    </div>
                    
                    {/* Stats Indicators */}
                    <div className="flex items-center gap-3 flex-shrink-0 ml-2">
                      {/* Offensive Efficiency */}
                      <div className="flex flex-col items-center w-8">
                        <div className="w-full h-1 bg-red-900/30 rounded-full mb-1">
                          <div 
                            className="h-1 bg-red-500 rounded-full" 
                            style={{ width: `${Math.max(0, Math.min(100, (stats.offensive_efficiency / 15) * 100))}%` }}
                          ></div>
                        </div>
                        <span className="text-xs text-red-400">{stats.offensive_efficiency > 0 ? stats.offensive_efficiency.toFixed(1) : "0.0"}</span>
                      </div>
                      
                      {/* Defensive Efficiency */}
                      <div className="flex flex-col items-center w-8">
                        <div className="w-full h-1 bg-blue-900/30 rounded-full mb-1">
                          <div 
                            className="h-1 bg-blue-500 rounded-full" 
                            style={{ width: `${Math.max(0, Math.min(100, (stats.defensive_efficiency / 15) * 100))}%` }}
                          ></div>
                        </div>
                        <span className="text-xs text-blue-400">{stats.defensive_efficiency > 0 ? stats.defensive_efficiency.toFixed(1) : "0.0"}</span>
                      </div>
                      
                      {/* Power Index */}
                      <div className="flex flex-col items-center ml-1 w-10">
                        <div className="w-full h-1 bg-emerald-900/30 rounded-full mb-1">
                          <div 
                            className="h-1 bg-emerald-500 rounded-full" 
                            style={{ width: `${Math.max(0, Math.min(100, (stats.bpi / 25) * 100))}%` }}
                          ></div>
                        </div>
                        <span className="text-xs font-medium text-emerald-400">{stats.bpi.toFixed(1)}</span>
                      </div>
                    </div>
                  </button>
                );
              })
            ) : (
              <div className="text-center text-slate-400 py-6">No teams found matching "{searchTerm}"</div>
            )}
          </div>
          
          {/* Pagination controls */}
          {filteredTeams.length > teamsPerPage && (
            <div className="px-4 py-3 flex items-center justify-between sticky bottom-0 bg-slate-900 border-t border-slate-800">
              <button
                onClick={prevPage}
                disabled={currentPage === 1}
                className={`p-2 rounded-lg flex items-center justify-center
                  ${currentPage === 1 
                    ? 'text-slate-600 cursor-not-allowed' 
                    : 'text-slate-300 hover:bg-slate-700'}`}
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              
              <div className="text-sm text-slate-400">
                <span>{currentPage}</span>
                <span className="mx-1">of</span>
                <span>{totalPages}</span>
              </div>
              
              <button
                onClick={nextPage}
                disabled={currentPage === totalPages}
                className={`p-2 rounded-lg flex items-center justify-center
                  ${currentPage === totalPages 
                    ? 'text-slate-600 cursor-not-allowed' 
                    : 'text-slate-300 hover:bg-slate-700'}`}
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>

        {/* Right side: Team details */}
        {selectedTeam && (
          <div className="w-2/3 overflow-y-auto p-4">
            {/* Main team stat card */}
            <div className="bg-slate-800/50 rounded-lg border border-slate-700 p-4 mb-4">
              <div className="flex justify-between items-center mb-4">
                <div className="flex items-center">
                  {matchupInfo && (
                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-emerald-900/60 text-emerald-300 text-xs font-bold mr-2">
                      {matchupInfo.seed}
                    </span>
                  )}
                  <h4 className="text-lg font-medium text-emerald-400">{selectedTeam[0]}</h4>
                </div>
              </div>
              
              <div className="grid grid-cols-4 gap-3 mb-4">
                <div className="p-2 bg-slate-800 rounded border border-slate-700">
                  <div className="text-xs text-slate-400">Record</div>
                  <div className="text-white font-medium">{selectedTeam[1].record}</div>
                </div>
                <div className="p-2 bg-slate-800 rounded border border-slate-700">
                  <div className="text-xs text-slate-400">BPI Rank</div>
                  <div className="text-white font-medium">#{selectedTeam[1].bpi_rank}</div>
                </div>
                <div className="p-2 bg-slate-800 rounded border border-slate-700">
                  <div className="text-xs text-slate-400">Team Strength</div>
                  <div className="text-white font-medium">{selectedTeam[1].strength}</div>
                </div>
                <div className="p-2 bg-slate-800 rounded border border-slate-700">
                  <div className="text-xs text-slate-400">Overall Efficiency</div>
                  <div className="text-white font-medium">{selectedTeam[1].overall_efficiency.toFixed(1)}</div>
                </div>
              </div>
              
              <div className="mb-4">
                <div className="text-sm text-slate-300 mb-1">POWER Index: {selectedTeam[1].bpi.toFixed(1)}</div>
                <div className="w-full bg-slate-700 rounded-full h-2">
                  <div 
                    className="bg-emerald-500 h-2 rounded-full" 
                    style={{ width: `${(selectedTeam[1].bpi / 25) * 100}%` }}
                  ></div>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                <div className="p-2 bg-slate-800 rounded border border-slate-700">
                  <div className="text-xs text-slate-400">Offensive Efficiency</div>
                  <div className="text-emerald-400 font-medium">{selectedTeam[1].offensive_efficiency.toFixed(1)}</div>
                  <div className="w-full bg-slate-700 rounded-full h-2 mt-1">
                    <div 
                      className="bg-red-500 h-2 rounded-full" 
                      style={{ width: `${(selectedTeam[1].offensive_efficiency / 15) * 100}%` }}
                    ></div>
                  </div>
                </div>
                <div className="p-2 bg-slate-800 rounded border border-slate-700">
                  <div className="text-xs text-slate-400">Defensive Efficiency</div>
                  <div className="text-emerald-400 font-medium">{selectedTeam[1].defensive_efficiency.toFixed(1)}</div>
                  <div className="w-full bg-slate-700 rounded-full h-2 mt-1">
                    <div 
                      className="bg-blue-500 h-2 rounded-full" 
                      style={{ width: `${(selectedTeam[1].defensive_efficiency / 15) * 100}%` }}
                    ></div>
                  </div>
                </div>
              </div>
              
              {/* Power Score */}
              <div className="mt-4 p-2 bg-slate-800 rounded border border-slate-700">
                <div className="text-xs text-slate-400 mb-1">Power Score (Combined Metric)</div>
                <div className="text-emerald-400 font-medium">{selectedTeam[1].powerScore.toFixed(1)}</div>
                <div className="w-full bg-slate-700 rounded-full h-2 mt-1">
                  <div 
                    className="bg-emerald-500 h-2 rounded-full" 
                    style={{ width: `${(selectedTeam[1].powerScore / 25) * 100}%` }}
                  ></div>
                </div>
              </div>
            </div>

            {/* Bracket matchup info */}
            {matchupInfo ? (
              <div className="bg-slate-800/50 rounded-lg border border-slate-700 p-4 mb-4">
                <h5 className="text-emerald-300 font-medium mb-3 flex items-center">
                  <Shield className="w-4 h-4 mr-2" />
                  Tournament Matchup
                </h5>

                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div className="bg-slate-800 rounded border border-slate-700 p-3">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center">
                        <span className="w-5 h-5 rounded-full bg-emerald-900/60 text-emerald-300 text-xs font-bold flex items-center justify-center mr-2">
                          {matchupInfo.seed}
                        </span>
                        <span className="text-white">{selectedTeam[0]}</span>
                      </div>
                    </div>
                    <div className="text-xs font-medium px-2 py-0.5 bg-slate-700/50 rounded text-slate-300 inline-block">
                      {matchupInfo.region} Region
                    </div>
                  </div>
                  
                  <div className="bg-slate-800 rounded border border-slate-700 p-3">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center">
                        <span className="w-5 h-5 rounded-full bg-red-900/60 text-red-300 text-xs font-bold flex items-center justify-center mr-2">
                          {matchupInfo.opponentSeed}
                        </span>
                        <span className="text-white">{matchupInfo.opponent}</span>
                      </div>
                    </div>
                    <div className="text-xs font-medium text-slate-400 px-2 py-0.5 bg-slate-700/50 rounded inline-block">
                      Matchup #{matchupInfo.matchupId}
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="flex items-center p-2 bg-slate-800 rounded border border-slate-700">
                    <MapPin className="w-3.5 h-3.5 text-slate-400 mr-2" />
                    <div>
                      <div className="text-xs text-slate-400">Location</div>
                      <div className="text-white text-sm">{matchupInfo.location}</div>
                    </div>
                  </div>
                  <div className="flex items-center p-2 bg-slate-800 rounded border border-slate-700">
                    <Calendar className="w-3.5 h-3.5 text-slate-400 mr-2" />
                    <div>
                      <div className="text-xs text-slate-400">Game Day</div>
                      <div className="text-white text-sm">{matchupInfo.date}</div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-slate-800/50 rounded-lg border border-slate-700 p-4 text-center">
                <p className="text-slate-400 text-sm">No tournament matchup data available</p>
              </div>
            )}

            {/* AI Analysis Button */}
            {matchupInfo && onSuggestionClick && (
              <div className="mb-4">
                <button
                  onClick={handleAskForOdds}
                  disabled={isGeneratingPrompt}
                  className={`w-full py-3 px-4 rounded-lg flex items-center justify-center gap-2 
                            text-sm font-medium transition-colors
                            ${isGeneratingPrompt 
                              ? 'bg-slate-700 text-slate-300 cursor-not-allowed border border-slate-600' 
                              : 'bg-emerald-700 text-white hover:bg-emerald-600 active:translate-y-0.5'}`}
                >
                  {isGeneratingPrompt ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white/30 border-t-white/80 rounded-full animate-spin"></div>
                      <span>Analyzing Matchup...</span>
                    </>
                  ) : (
                    <>
                      <Sparkles className="w-4 h-4" />
                      <span>Generate AI Game Analysis</span>
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopTeamStats;